import React from "react";

export default function DesignSolutionCard({ solution, summary, selected, onSelect }) {
  const muted = summary?.muted;
  return (
    <button
      type="button"
      data-testid={solution.testId}
      aria-pressed={selected}
      onClick={() => onSelect(solution.id)}
      className={`min-w-[9.5rem] max-w-[16rem] shrink-0 rounded-lg border px-3 py-2 text-left transition-colors ${
        selected
          ? "border-slate-800 bg-slate-800 text-white shadow-sm dark:border-slate-200 dark:bg-slate-200 dark:text-slate-900"
          : muted
            ? "border-slate-200 bg-slate-50/50 opacity-70 dark:border-slate-700 dark:bg-slate-900/30"
            : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900/60 dark:hover:bg-slate-800"
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <p
          className={`text-sm font-semibold ${
            selected
              ? "text-white dark:text-slate-900"
              : muted
                ? "text-slate-500 dark:text-slate-400"
                : "text-slate-800 dark:text-slate-100"
          }`}
        >
          {solution.label}
        </p>
        {muted ? (
          <span className="rounded-md bg-slate-100 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-slate-500 dark:bg-slate-800 dark:text-slate-400">
            Out of scope
          </span>
        ) : null}
      </div>
      {summary?.chips?.length ? (
        <div className="mt-1.5 flex flex-wrap gap-1">
          {summary.chips.map((chip) => (
            <span
              key={chip}
              className={`rounded border px-1.5 py-0.5 text-[11px] ${
                selected
                  ? "border-white/20 bg-white/10 text-slate-100 dark:border-slate-400/40 dark:bg-slate-900/10 dark:text-slate-700"
                  : "border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-600 dark:bg-slate-800/80 dark:text-slate-300"
              }`}
            >
              {chip}
            </span>
          ))}
        </div>
      ) : null}
    </button>
  );
}
